import { render } from "./PortfolioTradePostingCardComponent.vue?vue&type=template&id=0f3abe63&scoped=true&ts=true"
import script from "./PortfolioTradePostingCardComponent.vue?vue&type=script&lang=ts"
export * from "./PortfolioTradePostingCardComponent.vue?vue&type=script&lang=ts"

import "./PortfolioTradePostingCardComponent.vue?vue&type=style&index=0&id=0f3abe63&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3abe63"]])

export default __exports__